import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export const AuthFail = () => {
  const navigate = useNavigate();
  
  return (
    <Result
      status="403"
      title="Sorry, you are not authorized to access this page."
      extra={
        <Button type="primary" onClick={() => navigate("/login")}>
          Back Home
        </Button>
      }
    />
  );
};
